<template>
  <b-card class="bg-white rounded-xl px-4">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('cms-quotes')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Quote</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <p>Title</p>
        <base-input
          alternative
          class="mb-3"
          name="Title"
          :rules="{ required: true }"
          placeholder="Title"
          v-model="title"
          :maxlength="250"
          @input="limitTitle"
        >
        </base-input>
        <p>only this much Characters are allowed {{ title.length }} / 250</p>
        <br />
        <p>Image (Recommended resolution is 300 x 300 px)</p>
        <FileUploader
          v-show="!coverImage"
          :image="image"
          :onSuccess="handleSuccess"
        />
        <Cropper
          class="cropper"
          :src="image"
          v-if="coverImage != ''"
          @change="handleCropperChange"
          ref="cropper"
          :stencil-props="{
            aspectRatio: 1 / 1,
            movable: true,
            resizable: true,
          }"
        />
        <!-- <p>Description</p>
        <base-input
          alternative
          class="mb-3"
          name="Description"
          placeholder="Description"
          v-model="Description"
          :rules="{ required: true }"
        >
        </base-input> -->

        <img :src="image" alt="" v-if="image" />
        <div class="flex cursor-pointer items-center my-2" v-if="image">
          <base-button type="danger" class="px-8" @click="handleRemove">
            Remove image
          </base-button>
        </div>
        <!-- <span v-if="imageErr" class="flex justify-center small text-danger">{{
          msg.image
        }}</span> -->
        <img v-if="image" :src="cropperImg" ref="cover" />

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            :src="$imageURL + '/' + image2"
            alt="uploaded-image"
          />

          <base-button
            v-if="image2"
            type="danger"
            class="px-8"
            @click="handleRemove"
          >
            Remove image
          </base-button>
        </div>
        <div class="py-4 customboxed">
          <p>Redirect Link ( Prefix this link with' https:// ' )</p>
          <base-input
            class="mb-3"
            name="Link"
            placeholder="https://www.example.com"
            v-model="link"
          >
          </base-input>
        </div>
        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Update</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

// import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";
import "vue-advanced-cropper/dist/style.css";
import { Cropper } from "vue-advanced-cropper";
// import Data from "../../../../../admin/pages/add-product/components/Data";

export default {
  components: {
    FileUploader,
    // quillEditor,
    Cropper,
  },
  data() {
    return {
      title: "",
      link: "",
      image: null,
      image2: "",
      coverImage: null,
      cropperImg: "",
      imageErr: false,
      msg: {
        name: "",
        image: "",
        date: "",
      },
      Description: "",
    };
  },
  methods: {
    limitTitle(event) {
      if (this.title.length > 250) {
        this.title = this.title.substring(0, 250);
      }
    },
    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, { type: mime });
    },
    handleCropperChange(img) {
      // console.log(img);
      this.cropperImg = this.$refs.cropper.getResult().canvas.toDataURL();
      this.coverImage = this.dataURLtoFile(img.canvas.toDataURL(), "image.png");
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
      } else if (!image.type.includes("image")) {
        this.$swal.fire({
          title: "File Type!",
          html: "<p style='text-align:center'>Please ensure that the file Type should be Image</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      } else {
        this.coverImage = image;
        this.readerData(image);
      }
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let Regex =
        /^(?:\s*|https?:\/\/[a-z0-9-]+(\.[a-z0-9-]+)*\.[a-z]{2,}(:\d{1,5})?(\/[^\s]*)?)$/i;
      if (this.link != "") {
        if (!Regex.test(this.link)) {
          this.$notify.error({
            message: "Please Enter Valid URL",
            position: "bottom-right",
          });
          return false;
        }
      }
      if (!this.coverImage && !this.image2) {
        this.$notify.error({
          message: "Please Select Image",
          position: "bottom-right",
        });

        return;
      }
      let FormData = require("form-data");
      let data = new FormData();

      data.append("id", this.selectedquotes._id);
      data.append("title", this.title.trim());
      // data.append("description", this.Description.trim());
      data.append("link", this.link ? this.link : "");
      if (this.coverImage) {
        data.append("image", this.coverImage);
      } else if (this.image2) {
        data.append("image", this.image2);
      }
      let loader = this.$loading();

      // if (!this.coverImage) {
      //   this.$swal.fire({
      //     text: "Please Select Image",
      //     confirmButtonText: "Okay",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      //   loader.close();
      //   return;
      // }
      try {
        const newsdata = await this.$store.dispatch(
          "quotes/update_quotes",
          data
        );

        if (newsdata.code == 200) {
          this.$router.push({ name: "cms-quotes" });
          this.$swal.fire({
            text: "Quote Successfully Updated",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
        }
        loader.close();
      } catch (error) {
        if (error.response.status) {
          this.$swal.fire({
            title: "Error",
            text: error.response.data.message,
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      }
    },
    handleRemove() {
      this.image = null;
      this.image2 = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
    init() {
      this.title = this.selectedquotes.title;
      this.link = this.selectedquotes.link || "";
      this.image2 = this.selectedquotes.image;
      // this.image = `${this.$imageURL}/${this.selectedquotes.image}`;
      // this.coverImage = this.selectedMedicalForUpdate.picture;
      this.Description = this.selectedquotes.description;
    },
  },
  computed: {
    //   ...mapState("medicalCancer", ["selectedMedicalForUpdate"]),
    ...mapState("quotes", {
      selectedquotes: "selectedquotes",
    }),
  },
  async mounted() {
    this.init();
    console.log("selectedquotes", this.selectedquotes);
  },
};
</script>
